import { cycleReportConstants } from "../../constants/client";

const initialState = {};

export default function cycleReport(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case cycleReportConstants.CYCLE_REPORT_LISTING_REQUEST:
      currentstate = {
        paginationOptions: null,
        list: null,
        loading: true
      };
      break;
    case cycleReportConstants.CYCLE_REPORT_LISTING_SUCCESS:
      currentstate = {
        list: action.payload.list,
        paginationOptions: action.payload.paginationOptions,
        loading: false
      };
      break;

    case cycleReportConstants.CYCLE_REPORT_DOWNLOAD_REQUEST:
      currentstate = { loading: true };
      break;
    case cycleReportConstants.CYCLE_REPORT_DOWNLOAD_SUCCESS:
      currentstate = { loading: false };
      break;

    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
